export function editableRole(role) {
  return role.level === "user" && role.archivedAt === null;
}
